import React from 'react';
import { Dialog } from 'store/types';
import {
  useDialogOptions,
  useAsyncDialogProps,
  useOpenedDialogs,
  closeDialog,
  resolveAsyncConfirmation,
} from 'store/Dialog';
import { Authenticated } from 'shared/components/Authenticated/Authenticated';
import { AsyncConfirmationDialog } from 'shared/components/dialog/AsyncConfirmationDialog/AsyncConfirmationDialog';
import { InviteTeamMemberDialog } from 'shared/components/dialog/InviteTeamMember/InviteTeamMemberDialog';
import { QuestionAnswerDialog } from 'shared/components/dialog/QuestionAnswerDialog/QuestionAnswerDialog';
import { PrintDialog } from 'shared/components/dialog/PrintDialog/PrintDialog';
import NoteDialog from 'shared/components/dialog/NoteDialog/NoteDialog';
import { PublishDialog } from 'views/LoggedIn/Document/components/PublishDialog';


export const DialogsContainer = () => {
  const dialogOptions = useDialogOptions();
  const asyncDialogProps = useAsyncDialogProps();
  const openedDialogs = useOpenedDialogs();

  return (
    <>
      <Authenticated>
        <InviteTeamMemberDialog
          open={openedDialogs[Dialog.InviteTeamMember]}
          onClose={() => closeDialog(Dialog.InviteTeamMember)}
        />

        {openedDialogs[Dialog.QuestionAnswerDialog] && (
          <QuestionAnswerDialog
            open={openedDialogs[Dialog.QuestionAnswerDialog]}
            onClose={() => closeDialog(Dialog.QuestionAnswerDialog)}
          />
        )}

        <NoteDialog
          key={dialogOptions[Dialog.NoteDialog]?.key}
          open={openedDialogs[Dialog.NoteDialog]}
          editNoteId={dialogOptions[Dialog.NoteDialog]?.editNoteId}
          item={dialogOptions[Dialog.NoteDialog]?.item}
          itemType={dialogOptions[Dialog.NoteDialog]?.itemType}
          onClose={() => closeDialog(Dialog.NoteDialog)}
        />
      </Authenticated>

      {openedDialogs[Dialog.PrintDocument] && (
        <PrintDialog
          open
          onClose={() => closeDialog(Dialog.PrintDocument)}
          options={dialogOptions[Dialog.PrintDocument]}
        />
      )}

      <AsyncConfirmationDialog
        open={asyncDialogProps.show}
        onClose={() => resolveAsyncConfirmation(false)}
        onConfirm={() => resolveAsyncConfirmation(true)}
        onCancel={() => resolveAsyncConfirmation(false)}
        title={asyncDialogProps.title}
        content={asyncDialogProps.content}
        confirmLabel={asyncDialogProps.confirmLabel}
        cancelLabel={asyncDialogProps.cancelLabel}
      />

      {openedDialogs[Dialog.PublishDocument] && (
        <PublishDialog
          open={openedDialogs[Dialog.PublishDocument]}
          onClose={() => closeDialog(Dialog.PublishDocument)}
        />
      )}
    </>
  );
};